export default "__VITE_ASSET__FKKamxDy__"